var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErodeLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 18,
    viewBox: "0 0 79 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.16066H12.1192V5.01204H4.51781V7.33239H10.924V11.2076H4.51781V13.9586H12.1192V17.7861H0V1.16066Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5807 1.16066H22.2297C26.5799 1.16066 28.6358 4.34228 28.6358 7.33239C28.6358 9.62893 27.5838 11.7816 25.409 12.8105L28.9229 17.7861H23.6639L20.6522 13.4803H19.0985V17.7861H14.5807V1.16066ZM19.0985 9.557H21.9431C23.1622 9.557 24.2142 8.55235 24.2142 7.33239C24.2142 6.01668 23.1622 5.08397 21.9431 5.08397H19.0985V9.55748V9.557Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9335 1.16066H56.531C61.0012 1.16066 64.5389 3.76826 64.5389 9.48555C64.5389 14.3654 61.0012 17.7861 56.531 17.7861H49.9335V1.16066ZM56.1245 13.4803C58.0609 13.4803 59.973 12.1884 59.973 9.48555C59.973 6.78268 58.0609 5.46697 56.1245 5.46697H54.4513V13.4808H56.1245V13.4803Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8807 1.16066H78.9999V5.01204H71.3985V7.33239H77.8047V11.2076H71.3985V13.9586H78.9999V17.7861H66.8807V1.16066Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4681 9.23233C48.4681 13.3296 45.8056 16.7873 42.1358 18C42.1237 17.9815 42.1091 17.964 42.0926 17.947C41.399 17.2005 40.4894 15.683 42.2441 13.8691C45.8314 10.1699 41.8672 10.0134 39.8721 8.9825C37.4053 7.73435 40.4223 6.64076 41.4835 4.87887C42.5443 3.11697 40.7341 3.42026 40.7341 3.42026C40.7341 3.42026 42.5554 3.61565 38.8842 5.7552C35.2129 7.89475 35.4839 10.0839 36.5349 10.5884C37.7715 11.1838 39.6705 11.7524 36.2207 14.4213C35.2639 15.1654 34.599 16.0573 34.1376 16.922C31.6572 15.2699 30.0171 12.448 30.0171 9.23233C30.0171 4.15127 34.1653 0 39.2426 0C44.3199 0 48.4681 4.15127 48.4681 9.23233Z",
    fill: "#A2BBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErodeLogoBlack);
export default __webpack_public_path__ + "static/media/erode-logo-black.057af64fb3b89ede9ba4dd6742925086.svg";
export { ForwardRef as ReactComponent };